import { render, staticRenderFns } from "./HouseFundsDetailsView.vue?vue&type=template&id=0797d5d2&"
import script from "./HouseFundsDetailsView.vue?vue&type=script&lang=js&"
export * from "./HouseFundsDetailsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports